import type { Property } from '@stitches/core/types/css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
export const flexCenter = (_val: true) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const cutText = ({
  numberOfLines,
  textOverflow = 'ellipsis',
}: {
  numberOfLines: number;
  textOverflow?: Property.TextOverflow;
}) => ({
  '@supports(-webkit-box-orient: vertical)': {
    display: '-webkit-box',
    '-webkit-line-clamp': numberOfLines,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow,
  },
});

export const normalizeLink = ({ color = '$coreGreys100', fontSize = '$medium' }) => ({
  textDecoration: 'none',
  outLine: 'none',
  fontStyle: 'normal',
  fontFamily: '$default',
  fontSize,
  color,
  '-webkit-tap-highlight-color': 'transparent',
});
